










import Vue from "vue";
import Component from "vue-class-component";
import NumberInput from "@/components/common/NumberInput.vue";
import { Prop, Emit } from "vue-property-decorator";

@Component({
  components: {
    NumberInput
  }
})
export default class InvoiceInsBurden extends Vue {
  @Prop() item!: string;
  @Prop() unit_price!: number;
  @Prop() unit_num!: number;
  @Prop() total_money!: number;

  get Item() {
    return this.item;
  }
  set Item(newValue) {
    this.updateItem(newValue);
  }

  get UnitPrice() {
    return this.unit_price;
  }
  set UnitPrice(newValue) {
    this.updateUnitPrice(newValue);
    if (this.UnitNum != 0) {
      this.TotalMoney = newValue * this.UnitNum;
    }
  }

  get UnitNum() {
    return this.unit_num;
  }
  set UnitNum(newValue) {
    this.updateUnitNum(newValue);
    if (this.UnitPrice != 0) {
      this.TotalMoney = this.UnitPrice * newValue;
    }
  }

  get TotalMoney() {
    return this.total_money;
  }
  set TotalMoney(newValue) {
    this.updateTotalMoney(newValue);
    this.updateTotalIns();
  }

  @Emit("update:item")
  private updateItem(newValue: unknown) {
    return newValue;
  }

  @Emit("update:unit_price")
  private updateUnitPrice(newValue: unknown) {
    return newValue;
  }

  @Emit("update:unit_num")
  private updateUnitNum(newValue: unknown) {
    return newValue;
  }

  @Emit("update:total_money")
  private updateTotalMoney(newValue: unknown) {
    return newValue;
  }

  @Emit("deleteItem")
  private deleteItem() {
    return;
  }

  @Emit("updateTotalIns")
  private updateTotalIns() {
    return;
  }
}
